import type { EditImageRequest } from '@pulsify/shared/dto'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { editApi } from '../api'

interface EditVars {
  file: File
  params: EditImageRequest
}

export function useEditImage(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ file, params }: EditVars) => editApi.apply(businessId, file, params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.GENERATED_ASSETS, businessId),
      })
    },
  })
}
